var swiper = new Swiper(".banner_section .banner_slider", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    parallax: true,
    speed: 400,
    effect: "fade",
    draggable: false,
    allowTouchMove: false,
    navigation: {
        nextEl: ".banner_section .swiper-button-next",
        prevEl: ".banner_section .swiper-button-prev",
    },
});


var swiperAnnouce = new Swiper(".annoucment_bar .annouce_bar_slider", {
    loop: true,
    spaceBetween: 0,
    draggable: true,
    allowTouchMove: true,
    speed: 400,
    speed: 600,
    breakpoints: {
        "0": {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        "768": {
          slidesPerView: 4,
        },
        "900": {
          slidesPerView: 5,
          draggable: false,
          allowTouchMove: false,
        },
      },
});


document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("newsletter-popup");
  const closeBtn = document.querySelector(".popup-close");

  // Show after 2 seconds
  setTimeout(() => {
    popup.style.display = "flex";
  }, 2000);

  // Close only when clicking the × button
  closeBtn.addEventListener("click", () => {
    popup.style.display = "none";
  });
});